module.exports = __webpack_public_path__ + "img/special_banner_sample.73231d96.png";